/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, Input } from '@angular/core';
import { TypeOfVerticalAlignment, TypeOfPosition, NotificationMessageData } from '../../types';

@Component({
    selector: 'ui-message-block',
    template: require('./ui-message-block.html'),
    styles: [require('./ui-message-block.less')],
})

export class UiMessageBlock {

    @Input() verticalAlign: TypeOfVerticalAlignment = 'center';
    @Input() trianglePosition: TypeOfPosition = null;
    @Input() position: string = '';
    @Input() stringData: Array<NotificationMessageData> = [];
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-message-block/ui-message-block.ts